import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';
let {
  TABLE_BG_COLOR,
  TABLE_HEADER_TEXT_COLOR,
  TABLE_TEXT_COLOR,
  TABLE_DATA_BG_COLOR,
  TABLE_DATA_BORDER_COLOR,
  TABLE_SELECTED_COLOR,
  BUTTON_DARK_BG_COLOR,
  BUTTON_DARK_HOVER_BG_COLOR
} = constants;

let styles = {
  hide: {
    display: 'none'
  },
  noData: {
    paddingLeft: 4,
    paddingRight: 4,
    fontWeight: 600,
    verticalAlign: 'middle'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 33,
    textTransform: 'uppercase',
    textAlign: 'left',
    boxSizing: 'border-box',
    fontSize: '0.75em',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderBottom: `1px solid ${TABLE_DATA_BORDER_COLOR}`,
    ':nth-child(1n) ul': {
      textTransform: 'none',
      width: 140,
      left: '-32px',
      ':before': {
        left: 63
      }
    }
  },
  headerTitle: {
    backgroundColor: TABLE_BG_COLOR,
    color: TABLE_HEADER_TEXT_COLOR,
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  headerIcon: {
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    marginLeft: 8
  },
  headerIconClose: {
    top: 12,
    borderTop: '10px solid white'
  },
  headerIconOpen: {
    bottom: 12,
    borderBottom: '10px solid white'
  },
  data: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 33,
    backgroundColor: TABLE_DATA_BG_COLOR,
    borderBottom: `1px solid ${TABLE_DATA_BORDER_COLOR}`,
    boxSizing: 'border-box',
    fontSize: '0.9em',
    textAlign: 'left',
    verticalAlign: 'middle',
    color: TABLE_TEXT_COLOR
  },
  dataSelected: {
    backgroundColor: TABLE_SELECTED_COLOR,
    borderBottom: 'none'
  },
  btn: {
    padding: '0 20px 0 0',
    textAlign: 'right',
    verticalAlign: 'middle',
    width: 80,
    flexShrink: 0
  },
  editBtn: {
    fontSize: '0.9em',
    maxHeight: 33,
    boxSizing: 'border-box',
    fontWeight: 400,
    textTransform: 'none',
    padding: '5px 6px'
  },
  editBtnSelected: {
    backgroundColor: BUTTON_DARK_BG_COLOR,
    ':hover': {
      backgroundColor: BUTTON_DARK_HOVER_BG_COLOR
    }
  },
  cell: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  iconParent:{
    width: 30,
    cursor:'pointer',
    minWidth: 30,
    textAlign: 'center',
    padding:'10px'
  },
  iconExpand:{
    fontSize:'8px'
  },
  rowExpanded:{
    borderBottom: 'none'
  },
  extendedRow:{
    backgroundColor:TABLE_DATA_BG_COLOR,
    paddingLeft: '48px'
  },
  rowSelected:{
    backgroundColor:TABLE_SELECTED_COLOR,
    paddingLeft: '48px'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/datatable/datatablegroup/DataTableGroup.styles.js